import React from 'react';
import { observer } from 'mobx-react-lite';
import chatStore from '../stores/chatStore';
import { useTheme } from '../theme/ThemeContext';

const ScrollToBottom = observer(({ onClick }) => {
    const { theme } = useTheme();
    if (chatStore.stickToBottom) return null;
    return (
        <button
            type="button"
            onClick={onClick}
            className={`absolute bottom-4 left-1/2 z-10 -translate-x-1/2 rounded-full border px-3 py-1.5 text-xs shadow ${
                theme === 'dark'
                    ? 'border-white/15 bg-[#2f2f2f] text-white'
                    : 'border-black/10 bg-white text-black'
            }`}
        >
            Прокрутить вниз
        </button>
    );
});

export default ScrollToBottom;
